import { Routes } from '@angular/router';
import { RouteAccessGuard } from '@app/core/guards/route-access.guard';
import { DatadogDashboardComponent } from '@app/features/datadog/modules/datadog-dashboard/datadog-dashboard.component';
import { Authority } from '@app/shared/utils/enums';

export const datadogRoutes: Routes = [
    {
        path: 'datadog',
        children: [
            {
                path: '',
                component: DatadogDashboardComponent,
                // No `reuse: true` here, unlike the sibling health pages. Reuse works by
                // detaching and later re-inserting the page's DOM, and re-inserting an
                // iframe makes the browser reload it from its existing src -- which by
                // then holds a spent single-use login token, so Datadog answers with
                // "Refresh the page to continue". Rebuilding the page signs a new URL.
                data: {
                    authorities: [Authority.ADMIN, Authority.LOGIN, Authority.RESTAURANT_VIEW, Authority.HELP_1, Authority.UPDATE]
                },
                canActivate: [RouteAccessGuard]
            }
        ]
    }
]
